//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getWorkOrderTasks} from '../../../../api/workOrder'
import WorkOrderCell from "../componets/work-order-cell";
import PageSearchHeader from "../componets/page-search-header";

export default {
    name: "page-list-view",
    components: {PageSearchHeader, WorkOrderCell},
    data() {
        return {
            list: [],
            refreshing: false,
            pageIndex: 0,
            pageSize: 10,
            loading: false,
            finished: false,
            searchInput: {}
        }
    },
    props: {
        status: Number
    },
    methods: {
        workDetail(item) {
            this.$router.push({
                name: 'workSheetDetail',
                params: {
                    id: item.id
                }
            })
        },
        onRefresh() {
            this.pageIndex = 1;
            this.getWorkOrders();
        },
        onLoad() {
            this.pageIndex++;
            this.getWorkOrders()
        },
        getWorkOrders() {
            const vm = this;
            this.refreshing = this.pageIndex === 1;
            this.loading = this.pageIndex > 1;
            // const page = {
            //     maxResultCount: this.pageSize,
            //     skipCount: (this.pageIndex - 1) * this.pageSize,
            //     status: this.status,
            //     filter: this.searchInput.filter,
            // };
            this.searchInput.status = this.status;
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.pageIndex - 1) * this.pageSize
            getWorkOrderTasks(this.searchInput).then((res) => {
                if (this.pageIndex === 1) {
                    vm.list = [];
                }
                vm.list.push(...res.data.result.items);
                if (res.data.result.items.length < this.pageSize) {
                    vm.finished = true;
                } else {
                    vm.finished = false;
                }
            }).then(() => {
                vm.refreshing = false;
                vm.loading = false;
            }).catch((error) => {
                vm.refreshing = false;
                vm.loading = true;
            }).finally(() => {
                // this.refreshing = false;
                // this.loading = true;
            });
        },

        handleSearch(data) {
            this.searchInput = data;
            this.onRefresh();
        },
    },
    created() {

    }
}
